var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8336 9.75839V9.23984C16.8336 9.16225 16.8336 9.12345 16.8332 9.09063C16.7976 6.6107 14.7959 4.60892 12.3159 4.57341C12.2831 4.57294 12.2443 4.57294 12.1667 4.57294H11.6482M20.0746 10.4066V9.49911C20.0746 8.72486 20.0746 8.33773 20.0454 8.01141C19.7291 4.47795 16.9287 1.67761 13.3953 1.36125C13.0689 1.33203 12.6818 1.33203 11.9076 1.33203L11.0001 1.33203M8.04637 7.95347C7.6309 8.90661 7.84117 10.0169 8.57639 10.7521L10.7735 12.9492C11.5087 13.6844 12.619 13.8947 13.5721 13.4792C14.5253 13.0637 15.6356 13.274 16.3708 14.0092L17.7074 15.3459C17.7722 15.4107 17.8046 15.4431 17.8308 15.4716C18.4753 16.173 18.4753 17.2511 17.8308 17.9525C17.8046 17.981 17.7722 18.0134 17.7074 18.0781L16.895 18.8906C16.2333 19.5523 15.2795 19.83 14.3661 19.627C8.14228 18.244 3.28163 13.3833 1.89856 7.15951C1.69558 6.24608 1.97333 5.29227 2.63498 4.63062L3.44746 3.81814C3.51222 3.75338 3.5446 3.721 3.57312 3.69479C4.27452 3.0503 5.35262 3.0503 6.05401 3.69479C6.08254 3.721 6.11492 3.75338 6.17967 3.81814L7.51635 5.15482C8.25157 5.89004 8.46184 7.00034 8.04637 7.95347Z",
    opacity: 0.5,
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.cabfad7f.svg";
export { ForwardRef as ReactComponent };